import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";

export const Isologotipo = styled((props) => {
  const { variant, ...other } = props;

  const color = variant === "light" ? "#ffffff" : "#85c6f3";

  return (
    <svg
      width="263" 
      height="39"
      viewBox="0 0 263 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_158_16)">
        <path
          d="M40.7207 1.47205H69.3003V8.23719H48.6134V15.6757H69.3004V22.3782H48.6134V31.2262H69.3004V37.9913H40.7207V1.47205Z"
          fill="#40C1AC"
        />
        <path
          d="M73.873 19.6849C73.873 9.3179 81.8753 0.908447 93.1506 0.908447C98.1618 0.908447 102.672 2.59973 105.945 5.52816L101.09 10.8213C98.6159 8.67584 96.079 8.0651 93.5891 8.0651C86.9335 8.0651 82.0946 13.2486 82.0946 19.6849C82.0946 26.2151 86.8239 31.4612 93.3072 31.4612C96.6898 31.4612 99.7904 30.1614 102.045 27.6872L106.947 33.2152C103.455 36.5977 98.7099 38.6335 93.1349 38.6335C81.8753 38.6179 73.873 30.2241 73.873 19.6849Z"
          fill="#40C1AC"
        />
        <path
          d="M112.49 1.47205H141.07V8.23719H120.383V15.6757H141.07V22.3782H120.383V31.2262H141.07V37.9913H112.49V1.47205Z"
          fill="#40C1AC"
        />
        <path
          d="M147.883 1.47205H163.559C174.27 1.47205 179.908 7.78305 179.908 15.5661C179.908 23.3492 174.27 29.6602 163.512 29.6602H155.791V38.007H147.898V1.47205H147.883ZM163.903 22.895C168.585 22.895 171.623 19.6221 171.623 15.5661C171.623 11.5101 168.585 8.23719 163.95 8.23719H155.775V22.895H163.903Z"
          fill="#40C1AC"
        />
        <path
          d="M194.91 1.47205H202.677L218.572 38.007H210.57L208.095 32.1971H189.554L187.08 38.007H179.015L194.91 1.47205ZM205.621 26.0583L201.393 15.6287C200.265 12.8726 198.856 9.20812 198.793 9.08283C198.731 9.19245 197.321 12.8569 196.194 15.6287L191.966 26.0583H205.621Z"
          fill="#40C1AC"
        />
        <path
          d="M230.709 1.47205H223.881V38.007H231.774L231.1 14.8457L239.102 38.007L243.049 25.7765L230.709 1.47205ZM239.102 38.007H246.995L243.049 25.7765L241.483 30.6311L239.102 38.007ZM255.389 1.47205L243.049 25.7608L246.995 37.9913L254.997 14.8301L254.324 37.9913H262.217V1.47205H255.389Z"
          fill="#40C1AC"
        />
        <path
          d="M25.1344 25.7765C29.6445 23.3492 32.0718 18.8391 32.0718 14.1567C32.0718 6.32666 26.4342 0 15.6757 0H0V5.70026C0 10.0538 3.53918 13.5929 7.89267 13.5929L17.6802 11.6511L9.0202 11.933L8.14323 8.45643C8.01795 7.84569 8.56606 7.29759 9.1768 7.40721L23.5371 10.0694C24.2888 10.2104 24.5237 11.15 23.9286 11.6354L12.0896 20.7339C11.5571 21.1411 10.7585 20.8592 10.6175 20.2015L9.9598 17.1164L7.73607 17.1008C3.46087 17.1008 0 20.5617 0 24.8369V36.5193H7.89267V28.2351H14.9397C16.0046 28.2351 16.9755 28.1255 18.0404 27.9532L23.678 36.5193H32.7609L25.1344 25.7765Z"
          fill="#40C1AC"
        />
      </g>
      <defs>
        <clipPath id="clip0_158_16">
          <rect width="262.217" height="38.6335" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
})``;

Isologotipo.defaultProps = {
  variant: "primary",
};

Isologotipo.propTypes = {
  variant: PropTypes.oneOf(["light", "primary"]),
};
